import React from 'react';
import posthog from 'posthog-js';

interface Props {
  children: React.ReactNode;
  fallback: React.ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * A React error boundary that captures unhandled errors and reports them to
 * PostHog via `posthog.captureException()`.  Replaces the former
 * `Sentry.ErrorBoundary` wrapper in `index.tsx`.
 */
class PostHogErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error: Error): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    // Note: stack traces will be minified until PostHog sourcemap upload is configured
    // in the CI build (see ci/build-ui.sh).
    posthog.captureException(error, {
      extra: { componentStack: info.componentStack },
    });
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}

export default PostHogErrorBoundary;
